import { render, staticRenderFns } from "./edit.variables.page.vue?vue&type=template&id=3240db0d&"
import script from "./edit.variables.page.vue?vue&type=script&lang=js&"
export * from "./edit.variables.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports